import { A as r } from "./element-CV9utnHJ.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const m = (o) => o ?? r;
export {
  m as o
};
